class LangPrimary {
  constructor() {
    this.trigger = document.querySelectorAll('[data-trigger="flag"]');
    this.target = document.querySelector('[data-target="flag"]');

    if (this.target) {
      this._init();
    }
  }

  _init() {
    for (let element of this.trigger) {
      element.addEventListener("click", event =>
        this._toggleNav(event, element)
      );
    }
  }

  _toggleNav(event, element) {
    this._toggleState(this.target, element, "open", "closed");
  }

  _toggleState(elem, element, one, two) {
    const newState = elem.getAttribute("data-state") === one ? two : one;
    elem.setAttribute("data-state", newState);
    window.addEventListener("click", function(e) {
      if (newState === one) {
        if (!element.contains(e.target)) {
          elem.setAttribute("data-state", "closed");
        }
      }
    });
  }
}

export let langPrimary = new LangPrimary();
